import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CorrespondenceTeamStoreActions,
  CorrespondenceTeamStoreSelectors,
  CorrespondenceTeamStoreReducer,
} from './index';
import { CorrespondenceTeamDto } from '@cradua/data';

@Injectable()
export class CorrespondenceTeamFacade {
  constructor(
    private store: Store<
      CorrespondenceTeamStoreReducer.CorrespondenceTeamPartialState
    >
  ) {}

  correspondenceTeam$ = this.store.select(
    CorrespondenceTeamStoreSelectors.getSelected
  );
  correspondenceTeamError$ = this.store.select(
    CorrespondenceTeamStoreSelectors.getCorrespondenceTeamError
  );

  getselected() {
    return this.store.select(CorrespondenceTeamStoreSelectors.getSelected);
  }

  get isLoadingCorrespondenceTeam() {
    this.store.dispatch(
      CorrespondenceTeamStoreActions.loadCorrespondenceTeam()
    );
    return this.store.select(
      CorrespondenceTeamStoreSelectors.loadingCorrespondenceTeam
    );
  }

  get loadCorrespondenceTeam() {
    this.store.dispatch(
      CorrespondenceTeamStoreActions.loadCorrespondenceTeam()
    );
    return this.store.select(
      CorrespondenceTeamStoreSelectors.getAllCorrespondenceTeam
    );
  }

  addCorrespondenceTeam(newCorrespondenceTeam: CorrespondenceTeamDto[]) {
    this.store.dispatch(
      CorrespondenceTeamStoreActions.addCorrespondenceTeam({
        newCorrespondenceTeam,
      })
    );
  }

  updateCorrespondenceTeam(updateCorrespondenceTeam: CorrespondenceTeamDto[]) {
    this.store.dispatch(
      CorrespondenceTeamStoreActions.updateCorrespondenceTeam({
        updateCorrespondenceTeam,
      })
    );
  }

  removeCorrespondenceTeam(ids: string[]) {
    this.store.dispatch(
      CorrespondenceTeamStoreActions.removeCorrespondenceTeam({ ids })
    );
  }
}
